import { render, staticRenderFns } from "./ffTips.vue?vue&type=template&id=1822dcd0&scoped=true"
import script from "./ffTips.vue?vue&type=script&lang=js"
export * from "./ffTips.vue?vue&type=script&lang=js"
import style0 from "./popover.scss?vue&type=style&index=0&id=1822dcd0&prod&lang=scss&scoped=true&external"
import style1 from "./ffTips.vue?vue&type=style&index=1&id=1822dcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822dcd0",
  null
  
)

export default component.exports